import {
  IEcommerce,
  IGtmEventsBuyMiner,
  IGtmEventsClick,
  IGtmEventsClickMapped,
  IGtmEventsPageView,
  IItems,
} from './types';

export const gtmEventsSender = (
  data: IGtmEventsClick | IGtmEventsPageView | IGtmEventsBuyMiner,
): void => {
  window.dataLayer.push(data);
};

export const gtmEventsPageViewSender = ({
  cityId = 0,
  cityName = '',
  userAuth,
  userId = 0,
  pageType = '',
}: IGtmEventsPageView): void => {
  gtmEventsSender({
    cityId,
    cityName,
    userAuth,
    userId,
    pageType,
  });
};

export const gtmEventsClickSender = ({
  event = 'gtm-event',
  gtmEventCategory = '',
  gtmEventAction = '',
  gtmEventLabel = '',
  gtmEventContent = '',
}: IGtmEventsClickMapped): void => {
  gtmEventsSender({
    event: event,
    gtmEventCategory: gtmEventCategory,
    gtmEventAction: gtmEventAction,
    gtmEventLabel: gtmEventLabel,
    gtmEventContent: gtmEventContent,
  });
};

export const gtmClickCart = (
  itemName: string,
  itemId: number,
  price: number,
  itemBrand: string,
  itemHashRate: number,
  itemElectricityFee: number,
): void => {
  gtmEventsSender({
    event: 'add_to_cart',
    ecommerce: {
      items: [
        {
          item_name: itemName,
          item_id: itemId,
          price: price,
          item_brand: itemBrand,
          item_hash_rate: itemHashRate,
          item_electricity_fee: itemElectricityFee,
          quantity: 1,
        },
      ],
    },
  });
};

export const gtmClickCartCheckout = (items: IItems[]): void => {
  gtmEventsSender({
    event: 'checkout',
    ecommerce: {
      items: items,
    },
  });
};

export const gtmClickPaymentSubmit = (ecommerce: IEcommerce): void => {
  gtmEventsSender({
    event: 'purchase',
    ecommerce: ecommerce,
  });
};

export const gtmClickDeposit = (): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'deposit account',
    gtmEventAction: 'click',
    gtmEventLabel: 'Deposit',
    gtmEventContent: 'Wallet',
  });
};

export const gtmClickWithdraw = (): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'withdraw account',
    gtmEventAction: 'click',
    gtmEventLabel: 'Withdraw',
    gtmEventContent: 'Wallet',
  });
};

export const gtmClickSendForm = (label: string): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'forms',
    gtmEventAction: 'send',
    gtmEventLabel: 'success',
    gtmEventContent: label,
  });
};

export const gtmClickSendRequestResetPassword = (): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'forms',
    gtmEventAction: 'click',
    gtmEventLabel: 'sendRequest',
    gtmEventContent: 'resetPassword',
  });
};

export const gtmClickEmailChange = (content: string): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'forms',
    gtmEventAction: 'input',
    gtmEventLabel: 'e-mail',
    gtmEventContent: content,
  });
};

export const gtmClickPasswordChange = (content: string): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'forms',
    gtmEventAction: 'input',
    gtmEventLabel: 'password',
    gtmEventContent: content,
  });
};

export const gtmClickFormError = (label: string, errorMessage: string): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'forms',
    gtmEventAction: 'error',
    gtmEventLabel: label,
    gtmEventContent: errorMessage,
  });
};

export const gtmClickResetPasswordConfirm = (): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'forms',
    gtmEventAction: 'click',
    gtmEventLabel: 'confirm',
    gtmEventContent: 'resetPassword',
  });
};

export const gtmClickSetNewPassword = (): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'forms',
    gtmEventAction: 'click',
    gtmEventLabel: 'newPassword',
    gtmEventContent: 'resetPassword',
  });
};

export const gtmClickForgotPassword = (): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'forms',
    gtmEventAction: 'click',
    gtmEventLabel: 'forgotPassword',
    gtmEventContent: 'Log in',
  });
};

export const gtmClickDepositProcess = (label: string): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'deposit account',
    gtmEventAction: 'click',
    gtmEventLabel: label,
    gtmEventContent: 'Wallet',
  });
};

export const gtmClickReplenish = (value: string): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'deposit electricity',
    gtmEventAction: 'click',
    gtmEventLabel: value,
    gtmEventContent: 'deposit electricity payment',
  });
};

export const gtmClickReplenishPaid = (): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'ecom',
    gtmEventAction: 'click',
    gtmEventLabel: 'Replenish',
    gtmEventContent: 'invoice paid successfully',
  });
};

export const gtmClickCopyAffiliateLink = (): void => {
  gtmEventsClickSender({
    gtmEventCategory: 'affiliate',
    gtmEventAction: 'click',
    gtmEventLabel: 'Copy link',
    gtmEventContent: 'affiliate program',
  });
};

//TRIAL
export const gtmClickStartTrial = (
  elementName:
    | 'start_trial_menu_button'
    | 'start_trial_banner_dashboard_button'
    | 'start_trial_banner_miners_page_button'
    | null,
): void => {
  if (!elementName) return;
  gtmEventsSender({
    event: '[TRIAL] click start trial button',
    gtmEventCategory: 'trial',
    gtmEventAction: 'click',
    gtmEventLabel: elementName,
    gtmEventContent: '',
  });
};

export const gtmClickAddToCartTrialMiner = (): void => {
  gtmEventsSender({
    event: '[TRIAL] click add to cart button',
    gtmEventCategory: 'trial',
    gtmEventAction: 'click',
    gtmEventLabel: 'add_to_cart',
    gtmEventContent: '',
  });
};

export const gtmViewRegistrationPageTrialMiner = (from: string): void => {
  gtmEventsSender({
    event: '[TRIAL] view registration page',
    gtmEventCategory: 'trial',
    gtmEventAction: 'view',
    gtmEventLabel: `registration_page_${from}`,
    gtmEventContent: '',
  });
};

export const gtmClickGoToDashboardAfterEmailSubscriptionTrial = (from?: string): void => {
  gtmEventsSender({
    event: '[TRIAL] click go to dashboard button after email subscription',
    gtmEventCategory: 'trial',
    gtmEventAction: 'click',
    gtmEventLabel: `go_to_dashboard_after_email_subscription${from ? '_' + from : ''}`,
    gtmEventContent: '',
  });
};

export const gtmViewInvoicePageWithTrialMiner = (): void => {
  gtmEventsSender({
    event: '[TRIAL] view invoice page',
    gtmEventCategory: 'trial',
    gtmEventAction: 'view',
    gtmEventLabel: 'invoice_page',
    gtmEventContent: '',
  });
};

export const gtmClickPayButtonTrialMiner = (): void => {
  gtmEventsSender({
    event: '[TRIAL] click pay button',
    gtmEventCategory: 'trial',
    gtmEventAction: 'click',
    gtmEventLabel: 'pay_button',
    gtmEventContent: '',
  });
};

export const gtmViewPaymentOptionsPageTrialMiner = (
  option:
    | 'choose_payment_option_with_only_trial_mainer_in_cart'
    | 'choose_payment_option_with_trial_miner_and_other_miners_in_cart',
): void => {
  gtmEventsSender({
    event: '[TRIAL] view payment options page',
    gtmEventCategory: 'trial',
    gtmEventAction: 'view',
    gtmEventLabel: option,
    gtmEventContent: '',
  });
};

export const gtmClickPaymentOptionTrialMiner = (
  option: 'pay_with_btc_balance' | 'pay_with_alphapo(crypto)' | 'pay_with_mercuryo(card)',
): void => {
  gtmEventsSender({
    event: '[TRIAL] click payment option',
    gtmEventCategory: 'trial',
    gtmEventAction: 'click',
    gtmEventLabel: option,
    gtmEventContent: '',
  });
};

export const gtmViewPaymentSuccessPageTrialMiner = (): void => {
  gtmEventsSender({
    event: '[TRIAL] view payment success page with btc balance',
    gtmEventCategory: 'trial',
    gtmEventAction: 'view',
    gtmEventLabel: 'btc_balance_payment_success_page',
    gtmEventContent: '',
  });
};
